var _style, _rect, _rect2, _rect3, _polygon, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatimentArbre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Batiment",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.stbata0{fill:#605F71;}\r\n\t.stbata1{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "stbata0",
    width: 5.2,
    height: 17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 8.3,
    className: "stbata0",
    width: 6.5,
    height: 8.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 3.2,
    className: "stbata0",
    width: 5.5,
    height: 5.3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "stbata0",
    points: "14.2,0 11.5,2.9 17,2.9 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.8,
    y: 3.2,
    className: "stbata1",
    width: 1.7,
    height: 1.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.8,
    y: 6.6,
    className: "stbata1",
    width: 1.7,
    height: 1.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.8,
    y: 13.7,
    className: "stbata1",
    width: 1.7,
    height: 1.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.8,
    y: 10.2,
    className: "stbata1",
    width: 1.7,
    height: 1.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3,
    y: 13.7,
    className: "stbata1",
    width: 1.7,
    height: 1.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3,
    y: 10.2,
    className: "stbata1",
    width: 1.7,
    height: 1.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3,
    y: 6.8,
    className: "stbata1",
    width: 1.7,
    height: 1.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4.9,
    className: "stbata0",
    width: 6.5,
    height: 12.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 6.6,
    className: "stbata1",
    width: 1.7,
    height: 1.7
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 13.7,
    className: "stbata1",
    width: 1.7,
    height: 1.7
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 10.2,
    className: "stbata1",
    width: 1.7,
    height: 1.7
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    y: 16.5,
    className: "stbata1",
    width: 17,
    height: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatimentArbre);
export default __webpack_public_path__ + "static/media/Batiment-arbre.0741256a48bfb192be4ed952abb3f834.svg";
export { ForwardRef as ReactComponent };